// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryTimer_wrapper","tradein":"CategoryTimer_tradein","info":"CategoryTimer_info","title":"CategoryTimer_title","timer":"CategoryTimer_timer"};